var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#facebook_svg__clip0_5004_5401)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0A15.947 15.947 0 005.13 4.272 16.136 16.136 0 00.036 14.837a16.166 16.166 0 003.391 11.235A15.98 15.98 0 0013.501 32V20.751H9.438v-4.653h4.063V12.55c0-4.035 2.388-6.263 6.043-6.263 1.2.017 2.397.122 3.582.314v3.962h-2.018c-1.987 0-2.607 1.24-2.607 2.514v3.02h4.437l-.709 4.653h-3.728V32a15.981 15.981 0 0010.073-5.929 16.166 16.166 0 003.392-11.235A16.136 16.136 0 0026.87 4.272 15.946 15.946 0 0016 0z",
    fill: "#1877F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "facebook_svg__clip0_5004_5401"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
}
export default SvgFacebook;